import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { QueryProvider } from './lib/query-provider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from 'sonner';
import './i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <App />
        <Toaster position="top-right" richColors closeButton />
      </QueryProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
